"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetAFreeEstimateCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="get-a-free-estimate-cta" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`bg-primary text-primary-foreground rounded-2xl p-8 md:p-16 text-center shadow-xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 tracking-tight">
            Ready to Upgrade Your Home's Exterior?
          </h2>
          <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto text-primary-100">
            Get a comprehensive, no-obligation estimate for your roofing, siding, or gutter project today. No credit card needed. Takes 15 minutes. Our experts are ready to help you protect and beautify your home. Detailed pricing breakdown included.
          </p>
          <Button variant="secondary" size="lg" className="text-base h-14 px-8 rounded-lg" asChild>
            <Link to="/ContactPage">
              Schedule Your Free Expert Home Assessment
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}